import { z } from 'zod/v4';

export const fleetAddressSchema = z.object({
  city: z.string().nullable(),
  country: z.string().nullable(),
  county: z.string().nullable(),
  state: z.string().nullable(),
  stateName: z.string().nullable(),
  streetAddress: z.string().nullable(),
  zip: z.string().nullable(),
});

export type FleetAddress = z.infer<typeof fleetAddressSchema>;
